import { useEffect, useRef } from "react";
import { Col, Row } from "react-bootstrap";
import AppButton from "../buttons/app-button/app-button";
import styles from "./search.module.scss";
interface IProps {
  handleSearchChange: (searchText: string) => void;
  onSearch: () => void;
  placeholder: string;
  value: string;
  isWithOptions?: boolean;
  // How long typing has to pause before the search runs on its own; 0 waits for Enter or the button.
  debounceDelay?: number;
}

const Search = (props: IProps) => {
  const {
    handleSearchChange,
    onSearch,
    placeholder,
    isWithOptions,
    value,
    debounceDelay = 500,
  } = props;

  // Parents pass a new onSearch every render, so the timer reads the latest one from here.
  const onSearchRef = useRef(onSearch);
  onSearchRef.current = onSearch;
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  const clearTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = undefined;
    }
  };

  const searchNow = () => {
    clearTimer();
    onSearchRef.current();
  };

  useEffect(() => {
    if (!value) {
      onSearchRef.current();
      return;
    }

    if (debounceDelay <= 0) {
      return;
    }

    const timer = setTimeout(() => {
      timerRef.current = undefined;
      onSearchRef.current();
    }, debounceDelay);
    timerRef.current = timer;

    return () => clearTimeout(timer);
  }, [value, debounceDelay]);

  return (
    <div
      className={`${
        !isWithOptions
          ? styles[`search-wrapper`]
          : styles[`search-wrapper-style-two`]
      }`}
    >
      <Row className={`align-items-center`}>
        <Col className="pe-0">
          <input
            type="text"
            placeholder={placeholder}
            value={value}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              handleSearchChange(e.target.value);
            }}
            onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
              if (e.key === "Enter") {
                e.preventDefault();
                searchNow();
              }
            }}
            className={`${styles[`search-input`]} ps-2 w-100`}
          />
        </Col>
        <Col className="col-auto px-0">
          <AppButton
            text="Search"
            iconName="search"
            iconOnly
            size="medium"
            onClick={searchNow}
            type="button"
          />
        </Col>
      </Row>
    </div>
  );
};

export default Search;
